function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState, useContext, createContext, useMemo } from "react";
import { differenceInDays, endOfDay, parseISO, startOfDay, subDays, toDate } from "date-fns";
import { isEmpty } from "underscore";
import { Config } from "../../app.config";
import { compress, decompress, isDevMode } from "./Utils";
import { DataAPI, useDataQuery } from "./Api";
import { KeywordsRegex } from "./Constants";
var api = new DataAPI();
var idOptions = Config.id + "-options";
var idData = Config.id + "-data";
var prefersDarkMode = false;
if (typeof window !== "undefined") {
  prefersDarkMode = window.matchMedia("(prefers-color-scheme:dark)").matches;
}
var defaultState = {
  query: "",
  author: "",
  time: "".concat(Config.defaultTimeRange),
  selectionRange: {
    startDate: subDays(new Date(), Config.defaultTimeRange),
    endDate: new Date(),
    key: "selection"
  },
  sort: "desc",
  limit: 100,
  subreddit: "".concat(Config.defaultSubreddit)
};
var defaultOptions = {
  oldReddit: false,
  showDate: false,
  darkMode: prefersDarkMode,
  showSuggestions: true
};
var SearchContext = /*#__PURE__*/createContext(_objectSpread({
  setState: function setState() {
    return undefined;
  },
  setThreadFilters: function setThreadFilters() {
    return undefined;
  },
  search: function search() {
    return undefined;
  },
  reset: function reset() {
    return undefined;
  },
  searching: false,
  searched: false,
  error: null,
  comments: [],
  allData: [],
  threadFilters: {},
  filteredCount: 0,
  totalCount: 0,
  shareUrl: "",
  options: defaultOptions,
  setOptions: function setOptions() {
    return undefined;
  }
}, defaultState));
var SearchContextProvider = function SearchContextProvider(props) {
  var _useState = useState(defaultState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    threadFilters = _useState4[0],
    setThreadFilters = _useState4[1];
  var _useState5 = useState(defaultOptions),
    _useState6 = _slicedToArray(_useState5, 2),
    options = _useState6[0],
    setOptions = _useState6[1];
  var _useDataQuery = useDataQuery(api, state, options),
    refetch = _useDataQuery.refetch,
    error = _useDataQuery.error,
    data = _useDataQuery.data,
    isRefetching = _useDataQuery.isRefetching,
    fetchStatus = _useDataQuery.fetchStatus;
  var search = function search() {
    var resetFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (resetFilters) {
      setThreadFilters(function (prevThreadFilters) {
        return Object.fromEntries(Object.keys(prevThreadFilters).map(function (thread) {
          return [thread, true];
        }));
      });
    }
    refetch();
  };
  var loadSavedState = function loadSavedState() {
    var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!isEmpty(formData)) {
      if (formData.selectionRange && formData.selectionRange.startDate && formData.selectionRange.endDate) {
        formData.selectionRange.startDate = new Date(formData.selectionRange.startDate);
        formData.selectionRange.endDate = new Date(formData.selectionRange.endDate);
      }
      if (formData.hasOwnProperty("threadFilters") && formData.threadFilters && !isEmpty(formData.threadFilters)) {
        setThreadFilters(formData.threadFilters);
      }
      setState(_objectSpread(_objectSpread({}, defaultState), formData));
      if (shouldSearch) {
        setTimeout(search, 250);
      }
    }
  };
  useEffect(function () {
    var localStorageOptions = decompress(localStorage.getItem(idOptions));
    if (!isEmpty(localStorageOptions)) {
      // Load stored form data if exists
      setOptions(_objectSpread(_objectSpread({}, defaultOptions), localStorageOptions));
      if (isDevMode()) {
        console.log("[local storage] options: loaded");
      }
    }
    if (window.location.hash) {
      var formData = decompress(window.location.hash.slice(1));
      loadSavedState(formData, true);
      if (isDevMode()) {
        console.log("[location hash] state: loaded");
      }
      // Remove hash now that we have the data
      history.replaceState(null, null, " ");
      return;
    }
    var localStorageData = decompress(localStorage.getItem(idData));
    if (!isEmpty(localStorageData)) {
      // Load stored form data if exists
      loadSavedState(localStorageData);
      if (isDevMode()) {
        console.log("[local storage] state: loaded");
      }
    }
    // Load persisted state once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (!data) {
      return;
    }
    setThreadFilters(function (prevThreadFilters) {
      // Build a list of unique threads and sort
      var threadsOptions = {};
      var threadsList = Array.from(new Set(data.map(function (c) {
        return c.thread;
      }))).sort();
      var _iterator = _createForOfIteratorHelper(threadsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var thread = _step.value;
          thread || (thread = "none");
          if (!isEmpty(prevThreadFilters) && thread in prevThreadFilters) {
            threadsOptions[thread] = prevThreadFilters[thread];
          } else {
            threadsOptions[thread] = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return threadsOptions;
    });
  }, [data]);
  var comments = useMemo(function () {
    return (data || []).filter(function (comment) {
      var selected = Object.keys(threadFilters).filter(function (x) {
        return threadFilters[x];
      });
      if (!comment.thread) {
        return selected.includes("none");
      } else {
        return selected.includes(comment.thread);
      }
    });
  }, [threadFilters, data]);
  var shareUrl = "".concat(typeof window === "undefined" ? "/" : window.location.href, "#").concat(compress(_objectSpread(_objectSpread({}, state), {}, {
    threadFilters: threadFilters
  })));
  var searched = data !== undefined;
  var reset = function reset() {
    setThreadFilters({});
    setState(defaultState);
  };
  return /*#__PURE__*/React.createElement(SearchContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      setState: setState,
      search: search,
      error: error,
      comments: comments,
      allData: data,
      totalCount: (data || []).length,
      filteredCount: (comments || []).length,
      searching: fetchStatus === "fetching" || isRefetching,
      reset: reset,
      searched: searched,
      threadFilters: threadFilters,
      setThreadFilters: setThreadFilters,
      options: options,
      setOptions: setOptions,
      shareUrl: shareUrl
    })
  }, props.children);
};
var useSearchContext = function useSearchContext() {
  return useContext(SearchContext);
};
export { SearchContextProvider, useSearchContext };